<div class="container">
    <h2>Gifts</h2>
    <img  class="img-fluid" src="../../assets/Images/giftImage.jpg" alt="">
    <p>We are not expecting gifts from anyone your attendance is enough for us</p>
    <p>If you do want to gift then we are saving up for an extra special honeymoon so any contribution to this we would be welcome</p>
    <a href="https://paypal.me/sharonandstephen?locale.x=en_GB">Click to gift</a>
    <img src="../../assets/Images/IncasAndCoconuts.png" class="img-fluid">
    
</div>
